import { put } from 'redux-saga/effects';
import { fetchDownloadVideoApi } from 'common/api';
import { fetchDownloadVideoSuccessAction } from 'common/actions';
import { errorHandleAction } from 'components/error-handle/actions';
import { ErrorHandleEnum } from 'components/error-handle/enum';

export function* fetchDownloadVideoEffect({ payload: { videoId } }) {
  try {
    const video = yield fetchDownloadVideoApi(videoId);
    yield put(fetchDownloadVideoSuccessAction(video));
  } catch (error) {
    yield put(
      errorHandleAction(
        "UIT custom video download pages feature isn't enabled.",
        error.status,
        ErrorHandleEnum.UIT_REGULAR_DOWNLOAD_PAGE
      )
    );
  }
}
